import { IConditionMatch } from '@buoyhealth/common.buoy-types';
import { PUBLIC_SITE } from '../settings';

export async function searchConditions({
  query,
}: {
  query: string;
}): Promise<{ conditions: IConditionMatch[] }> {
  // Remove any punctuation to avoid breaking sanity query
  const sanitizedQuery = query.replace(/[^\w\s]|_/g, '');

  try {
    const url = `${PUBLIC_SITE}/content_search/conditions?query=${sanitizedQuery}`;
    const res = await fetch(url);
    if (res.ok) {
      return await res.json();
    }
    const responseBody = await res.json();
    const error = { data: { status: res.status, body: responseBody } };
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw error;
  } catch (err: any) {
    console.error(`Failed to get condition: ${err?.data?.message}`);
    throw err;
  }
}
